const print =
{
    agree    : 'Imprimer' ,
    disagree : 'Fermer' ,
    title    : 'Imprimer'
};

export default print ;
